import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectDocumentTitleWelcomeTexts } from '@/store/cms/welcome-texts/selectors';
import { Button } from '@/components/buttons/Button';

const ClosePrompt = ({
  closeModal,
  continueRegistration,
}: {
  closeModal: VoidFunction;
  continueRegistration: VoidFunction;
}) => {
  const intl = useIntl();
  const documentTitleWelcomeText = useSelector(selectDocumentTitleWelcomeTexts);

  return (
    <div className="text-white">
      <div className="text-center flex flex-col items-center gap-4">
        <span className="font-bold text-lg sm:text-xl">
          {intl.formatMessage({ id: 'registration.ontario.modalExit.title' })}
        </span>
        <div className="text-center flex flex-col items-center gap-2">
          <span className="text-base sm:text-[17px]">
            {intl.formatMessage({ id: 'registration.ontario.modalExit.subtitle' })}:
          </span>
          <span className="font-bold text-blue-blue text-base sm:text-[17px]">
            {documentTitleWelcomeText}
          </span>
        </div>
      </div>
      <div className="mt-8 flex flex-col gap-4">
        <Button
          onClickHandler={() => continueRegistration()}
          text={intl.formatMessage({ id: 'registration.ontario.modalExit.ctaContinue' })}
        />
        <Button
          data-cy="ontario-register-confirm-exit-modal-button"
          btnType="outline"
          onClickHandler={() => closeModal()}
          text={intl.formatMessage({ id: 'registration.ontario.modalExit.ctaExit' })}
        />
      </div>
    </div>
  );
};

export default ClosePrompt;
